import { css, Global } from "@emotion/react";

const globalStyles = css`
  .ant-picker .ant-picker-input > input[disabled] {
    color: inherit !important;
  }
`;
const SC = {
  GlobalStyles: <Global styles={globalStyles} />,
};
export default SC;
